<form [formGroup]="dependentForm">
  <div class=" d-flex flex-wrap justify-content-around g-3">
    <div class="col-6 p-3">
      <mwp-input [form]="dependentForm" labelName="First Name" nameForControl="firstName" />
    </div>
    <div class="col-6 p-3">
      <mwp-input [form]="dependentForm" labelName="Middle Name" nameForControl="middleName" />
    </div>
    <div class="col-6 p-3">
      <mwp-input [form]="dependentForm" labelName="Last Name" nameForControl="lastName" />
    </div>

    <div class="col-6 p-3">
      <mwp-dropdown [form]="dependentForm" labelName="Suffix" nameForControl="suffix" [data]="suffixes" [isListItemArray]="true" />
    </div>
    <div class="col-6 p-3">
      <mwp-dropdown [form]="dependentForm" labelName="Relationship" nameForControl="dependentRelationship" [data]="relationships" [isListItemArray]="true" />
    </div>
    <div class="col-6 p-3">
      <mwp-dropdown-enum [form]="dependentForm" labelName="Gender" nameForControl="dependentGender" [dataEnum]="genders" />
    </div>
    <div class="col-6 p-3">
      @if (isNewDependent) {
        <mwp-input [form]="dependentForm" labelName="Dependent SSN" nameForControl="dependentSsn" [maskType]="maskType.social" />
      }
      @if (!isNewDependent) {
        <mwp-input [form]="dependentForm" labelName="Dependent SSN" nameForControl="dependentSsn" [maskType]="maskType.last4WithMask" />
      }
    </div>
    <div class="col-6 p-3">
      <mwp-datepicker [form]="dependentForm" labelName="Date Of Birth" nameForControl="dependentDateOfBirth"></mwp-datepicker>
    </div>

    <div class="w-100 d-inline-flex justify-content-end p-3">
      <button class="mwp-button-secondary me-3" type="button" (click)="close()">
        Cancel
      </button>
      @if (!isContinueButton) {
        <button class="mwp-button-save" (click)="submitForm()" [disabled]="!dependentForm.valid">
          Save
        </button>
      }
      @if (isContinueButton) {
        <button class="mwp-button-save" (click)="submitForm()" [disabled]="!dependentForm.valid">
          Continue
        </button>
      }
    </div>
  </div>
</form>